/* eslint-disable */
import { useEffect, useCallback, useRef, useState, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import { Button } from '@mui/material';
import SelectPicker from 'rsuite/SelectPicker';
import Input from 'rsuite/Input';
// import ListTable from '../../../Components/ListTable/ListTable';
import styles from './VariantsThresholdListPage.module.scss';
import { notificationServices } from '../../../Services';
import variantsThresholdServices from '../../../Services/variantsThreshold.services';
import assetServices from '../../../Services/AssetServices/asset.services';
import { BackdropLoader } from '../../../Components/Loaders';
import UploadDataModal from '../../../Components/Modals/UploadDataModal/UploadDataModal';
// eslint-disable-next-line import/no-unresolved, import/extensions
// import { VirtualizedListTable } from '@/Components/VirtualizedListTable';
import { ListTable } from '@/Components/ListTable';
import { skuTypesList, useProductData } from '@/Helpers';
import { formActions, modalActions } from '@/Actions';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';

const TABLE_COLUMNS = [
	{
		title: 'UY Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Name',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'SKU Type',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Sub Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Unit',
		config: {
			type: 'DATA',
		},
	},
];
const SPECIAL_COLUMNS = [
	{
		title: 'Threshold',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Max Stock',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Recommended Stock',
		config: {
			type: 'DATA',
		},
	},
];
const ACTION_COLUMNS = [
	// {
	// title: 'View',
	// config: {
	// type: 'VIEW',
	// },
	// },
];

const COLMAP = {
	'UY Id': 'clientVariantId',
	Name: 'productNameDisplay',
	'SKU Type': 'skuType',
	'Sub Category': 'subCategoryName',
	Category: 'category',
	Unit: 'unit',
	Threshold: 'uniqueKey',
	'Max Stock': 'uniqueKey',
	'Recommended Stock': 'uniqueKey',
	'Asset Name': 'assetName',
	'Asset Id': 'assetId',
};

const skuTypes = ['ALL', ...skuTypesList];

// eslint-disable-next-line no-unused-vars
const generateInput = (value, onInputChange) => {
	return (
		<div className={styles['variant-input']}>
			<input
				className={styles.thres_input}
				type='number'
				value={value}
				onChange={onInputChange}
			/>
		</div>
	);
};

const VariantsThresholdListPage = (props) => {
	const {
		fetchVariantsThreshold,
		data,
		stores,
		fetchStoresList,
		updateVariantsThresholdList,
		toggleUploadDataModal,
		showUploadDataModal,
		payload,
	} = props;
	const listRef = useRef(null);
	const [searchQuery, setSearchQuery] = useState('');
	const [selectedStore, setSelectedStore] = useState(null);
	const [selectedSkuType, setSelectedSkuType] = useState(null);
	const [updateState, setUpdateState] = useState({});
	const [assetId, setAssetId] = useState(null);
	const [assetsList, setAssetsList] = useState([]);
	const [assetsLoading, setAssetsLoading] = useState(false);
	// eslint-disable-next-line no-unused-vars
	const [pageCount, setPageCount] = useState({
		currentPage: 1,
		prevPage: 0,
	});
	const [isLoading, setIsLoading] = useState(false);
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const { userRolesDict = {} } = userConfig || {};
	const isInternal =
		(Object?.values?.(userRolesDict ?? {}).includes('INTERNAL') ||
			Object?.values?.(userRolesDict ?? {}).includes('Internal')) &&
		[2, 3, 4].includes(level);
	const nonInternal =
		!Object?.values?.(userRolesDict ?? {}).includes('INTERNAL') &&
		!Object?.values?.(userRolesDict ?? {}).includes('Internal') &&
		[3, 4].includes(level);
	const products = useSelector(
		(state) => state?.form?.ALL_PRODUCTS?.data?.LIST
	);
	const dispatch = useDispatch();

	useEffect(() => {
		if (Array.isArray(products) && products?.length === 0) {
			useProductData(dispatch);
		}
	}, [products]);

	useEffect(() => {
		setIsLoading(true);
		fetchStoresList({
			entity: 'STORES',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		setIsLoading(false);
		return () => {
			updateVariantsThresholdList({
				entity: 'VARIANTS_THRESHOLD',
				method: 'LIST_DATA',
				innerField: 'data',
				data: [],
			});
		};
	}, []);

	// Fetch assets list from API
	const fetchAssetsListData = async (storeId) => {
		if (!storeId) return;
		setAssetsLoading(true);
		try {
			const result = await assetServices.assetProductInventoryService({
				req: { data: { storeId, type: 'Display Freezer' } },
			});
			if (result?.status === 'Success' && result?.data?.assets) {
				const formattedAssets = result.data.assets.map((asset) => ({
					value: asset.id,
					label: asset.name,
				}));
				setAssetsList(formattedAssets);
			} else {
				setAssetsList([]);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Error fetching assets:', error);
			setAssetsList([]);
		} finally {
			setAssetsLoading(false);
		}
	};

	useEffect(() => {
		if (selectedStore) {
			setAssetId(null);
			setAssetsList([]);
			fetchAssetsListData(selectedStore);
		}
	}, [selectedStore]);

	useEffect(() => {
		if (selectedStore && pageCount?.currentPage !== pageCount?.prevPage) {
			updateVariantsThresholdList({
				entity: 'VARIANTS_THRESHOLD',
				method: 'LIST_DATA',
				innerField: 'data',
				data: [],
			});
			fetchVariantsThreshold({
				entity: 'VARIANTS_THRESHOLD',
				req: {
					params: {
						storeId: selectedStore,
						productType:
							selectedSkuType === 'ALL' ? null : selectedSkuType,
						...(assetId && { assetId }),
					},
				},
				method: 'LIST_DATA',
				showNotification: true,
			});
		}
	}, [
		selectedStore,
		selectedSkuType,
		assetId,
		pageCount?.currentPage,
		pageCount?.prevPage,
	]);

	// eslint-disable-next-line no-unused-vars
	const flattenedData = useMemo(() => {
		const result = [];
		data?.forEach((product) => {
			product?.variants?.forEach((variant) => {
				result.push({
					...product,
					...variant,
					subCategoryName:
						products?.find((ele) => ele?.id === product?.id)
							?.subCategoryName || product?.subCategoryName,
					productNameDisplay: `${product?.productName} (${variant?.variantName})`,
					uniqueKey: `${product?.id}__${variant?.variantId}`, // Double underscore separator
				});
			});
		});
		return result;
	}, [data, products]);

	const filteredData = useMemo(() => {
		const assetData = assetsList?.find((ele) => ele?.value === assetId);
		return flattenedData.filter((item) =>
			item?.productNameDisplay
				?.toLowerCase()
				?.includes(searchQuery?.trim()?.toLowerCase())
		).map((item) => {
			return {
				...item,
				assetId: assetId,
				assetName: assetData?.label,
			};
		});
	}, [flattenedData, searchQuery, assetId, assetsList]);

	useEffect(() => {
		setUpdateState({});
		if (data?.length > 0) {
			let temp = {};
			data?.forEach((prod) => {
				prod?.variants?.forEach((variant) => {
					temp = {
						...temp,
						[prod?.id]: {
							...(temp?.[prod?.id] || {}),
							[variant?.variantId]: {
								threshold: variant?.threshold,
								maxStock: variant?.maxStock,
								recommendedStock: variant?.recommendedStock,
							},
						},
					};
				});
			});
			setUpdateState(temp);
		}
	}, [data]);

	const handleImport = async (uploadFile) => {
		try {
			setIsLoading(true);
			const response =
				await variantsThresholdServices.uploadVariantsThresholdData({
					data: {
						variantThreshold: uploadFile?.file,
						...(assetId && { assetId }),
					},
				});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				fetchVariantsThreshold({
					entity: 'VARIANTS_THRESHOLD',
					req: {
						params: {
							storeId: selectedStore,
							productType:
								selectedSkuType === 'ALL'
									? null
									: selectedSkuType,
							...(assetId && { assetId }),
						},
					},
					method: 'LIST_DATA',
					showNotification: true,
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message,
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error occured while uploading data',
			});
		} finally {
			setIsLoading(false);
		}
	};

	const uploadVariantsThresholdData = () => {
		toggleUploadDataModal(true, {
			heading: 'Upload Variant Threshold and Recommended Stock',
			handleImport,
		});
	};

	const handleExcelDownload = useCallback((header, fileData, fileName) => {
		const commonColumns = [];
		const downloadBtn = document.createElement('a');
		const csvData = [[...commonColumns, ...header], ...fileData];

		const csv = `${csvData
			.map((e) => {
				return e.join(',');
			})
			.join('\n ')}`;

		const encodedValue = new Blob([csv], {
			type: 'text/csv',
		});
		downloadBtn.href = window.URL.createObjectURL(encodedValue);
		downloadBtn.target = '_blank';
		downloadBtn.download = fileName;
		downloadBtn.click();
	}, []);

	const handleExport = () => {
		let headers = [
			'Item Code',
			'UY Item Id',
			'Store Id',
			'Store Code',
			'Store Name',
			'Product Category',
			'SKU Type',
			'Product Name',
			'Variant Name',
			'Threshold',
			'Recommended Stock',
			'Max Stock',
		];
		const assetData = assetsList?.find((ele) => ele?.value === assetId);
		if (assetId) {
			headers = ['Asset Id', 'Asset Name', ...headers];
		}
		const totalValues = [];
		const exportData = [];
		const selectedStoreNames = [];
		data?.forEach((product) => {
			product?.variants?.forEach((variant) => {
				exportData.push({
					clientVariantId: variant?.clientVariantId,
					variantId: variant?.variantId,
					storeId: product?.storeId,
					clientStoreId: product?.clientStoreId,
					storeName: product?.storeName,
					productCategory: product?.category,
					skuType: product?.skuType,
					productName: product?.productName?.split(',').join(' '),
					variantName: variant?.variantName,
					threshold: variant?.threshold,
					recommendedStock: variant?.recommendedStock,
					maxStock: variant?.maxStock,
					assetId: assetData?.value,
					assetName: assetData?.label,
				});
				selectedStoreNames.push(product?.storeName);
			});
		});
		exportData?.forEach((product) => {
			let row = [
				product?.clientVariantId,
				product?.variantId,
				product?.storeId,
				product?.clientStoreId,
				product?.storeName,
				product?.productCategory,
				product?.skuType,
				product?.productName,
				product?.variantName,
				product?.threshold,
				product?.recommendedStock,
				product?.maxStock,
			];
			if (assetId) {
				row = [assetData?.value, assetData?.label, ...row];
			}
			totalValues?.push(row);
		});
		const storeNames = [...new Set(selectedStoreNames)];
		handleExcelDownload(
			headers,
			totalValues,
			`Variant Threshold of Products for Stores ${storeNames?.join(',')}`
		);
	};

	const onInputChange = (val, prodId, varId, field) => {
		setUpdateState((prev) => {
			return {
				...prev,
				[prodId]: {
					...prev?.[prodId],
					[varId]: {
						...prev?.[prodId]?.[varId],
						[field]: val,
					},
				},
			};
		});
	};

	const TABLE_COLS = useMemo(() => {
		if (assetId) {
			return [
				// {
				// 	title: 'Asset Id',
				// 	config: {
				// 		type: 'DATA',
				// 	},
				// },
				// {
				// 	title: 'Asset Name',
				// 	config: {
				// 		type: 'DATA',
				// 	},
				// },
				...TABLE_COLUMNS,
			];
		}
		return TABLE_COLUMNS;
	}, [assetId]);

	const SPECIAL_ITEMS = {
		Threshold: (unknown, item) => {
			// ListTable might pass value as first arg, but we use uniqueKey for identification
			// The second arg is usually the row data
			const rowData =
				item || flattenedData.find((ele) => ele?.uniqueKey === unknown);
			const { id: prodId, variantId } = rowData || {};
			const value = updateState?.[prodId]?.[variantId]?.threshold ?? '';
			return generateInput(value, (e) =>
				onInputChange(e.target.value, prodId, variantId, 'threshold')
			);
		},
		'Max Stock': (unknown, item) => {
			const rowData =
				item || flattenedData.find((ele) => ele?.uniqueKey === unknown);
			const { id: prodId, variantId } = rowData || {};
			const value = updateState?.[prodId]?.[variantId]?.maxStock ?? '';
			return generateInput(value, (e) =>
				onInputChange(e.target.value, prodId, variantId, 'maxStock')
			);
		},
		'Recommended Stock': (unknown, item) => {
			const rowData =
				item || flattenedData.find((ele) => ele?.uniqueKey === unknown);
			const { id: prodId, variantId } = rowData || {};
			const value =
				updateState?.[prodId]?.[variantId]?.recommendedStock ?? '';
			return generateInput(value, (e) =>
				onInputChange(
					e.target.value,
					prodId,
					variantId,
					'recommendedStock'
				)
			);
		},
	};

	// const selectStore = (e) => {
	// setSelectedStore(e.target.value);
	// };

	const onSubmit = async () => {
		let editValues = {};
		data?.forEach((prod) => {
			prod?.variants?.forEach((variant) => {
				const current =
					updateState?.[prod?.id]?.[variant?.variantId] || {};
				const original = variant;
				// eslint-disable-next-line eqeqeq
				if (
					current?.threshold != original?.threshold ||
					current?.maxStock != original?.maxStock ||
					current?.recommendedStock != original?.recommendedStock
				) {
					editValues = {
						...editValues,
						[prod?.id]: {
							...editValues?.[prod?.id],
							[variant?.variantId]: {
								threshold: current?.threshold,
								maxStock: current?.maxStock,
								recommendedStock: current?.recommendedStock,
							},
						},
					};
				}
			});
		});
		try {
			const response = await variantsThresholdServices.editThreshold({
				params: {
					storeId: selectedStore,
					...(assetId && { assetId }),
				},
				data: {
					editValues,
				},
			});
			if (response?.statusCode === 200) {
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				fetchVariantsThreshold({
					entity: 'VARIANTS_THRESHOLD',
					req: {
						params: {
							storeId: selectedStore,
							productType:
								selectedSkuType === 'ALL'
									? null
									: selectedSkuType,
							...(assetId && { assetId }),
						},
					},
					method: 'LIST_DATA',
					showNotification: true,
				});
			} else {
				notificationServices.generateNotification({
					type: 'error',
					message: response?.message || 'Update failed',
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Some error occured',
			});
		}
	};

	const handleScroll = useCallback(() => {
		// if (listRef?.current) {
		// const { scrollTop, scrollHeight, clientHeight } = listRef.current;
		// if (Math.floor(scrollTop + clientHeight) === scrollHeight) {
		// console.log('CHeckkk');
		// setPageCount((prev) => {
		// return {
		// ...prev,
		// currentPage: prev?.currentPage + 1,
		// };
		// });
		// }
		// }
	}, []);

	const BASE_STORES = useMemo(() => {
		const tempStoreList = stores?.map((ele) => {
			return {
				...ele,
				label: ele?.name,
				role: ele?.type,
				value: ele?.id,
			};
		});
		return tempStoreList;
	}, [stores]);

	return (
		<div className={styles.root}>
			<BackdropLoader showProgress isLoading={isLoading} />
			<UploadDataModal
				show={showUploadDataModal}
				handleImport={handleImport}
				heading={payload?.heading}
			/>
			<div className={styles.header}>
				<div className={styles.filter}>
					<Input
						value={searchQuery}
						onChange={(value) => {
							setSearchQuery(value);
						}}
						style={{
							width: 200,
							borderRadius: 25,
							border: '1px solid #000',
						}}
						placeholder='Search Product'
					/>
					<div className={styles['store-container']}>
						{/* <TextField
							label='Select Store'
							className={styles['store-select']}
							select
							value={selectedStore}
							onChange={selectStore}
						>
							{stores?.map((ele) => {
								return (
									<MenuItem key={ele.id} value={ele.id}>
										{ele?.name}
									</MenuItem>
								);
							})}
						</TextField> */}
						<SelectPicker
							data={BASE_STORES}
							style={{
								width: 224,
							}}
							groupBy='role'
							placeholder='Select Store'
							onChange={(storeId) => {
								setSelectedStore(storeId);
							}}
							renderMenuItem={(_) => {
								return (
									<div>
										<i className='rs-icon rs-icon-user' />
										{_}
									</div>
								);
							}}
							renderMenuGroup={(_) => {
								return (
									<div>
										<i className='rs-icon rs-icon-group' />
										{_}
									</div>
								);
							}}
							value={selectedStore}
							cleanable={false}
							renderValue={(value, item) => {
								return (
									<div className='rsuite-select-picker-render-value'>
										{item?.label}
									</div>
								);
							}}
						/>
						{!selectedStore && (
							<p>Select Store to get Variants threshold</p>
						)}
					</div>
					{assetsList?.length > 0 && (
						<SelectPicker
							data={assetsList}
							value={assetId}
							onChange={(value) => setAssetId(value)}
							placeholder='Select Asset'
							searchable
							cleanable
							loading={assetsLoading}
							style={{ width: 200 }}
						/>
					)}
					{/* <TextField
						label='Select SKU Type'
						className={styles.selector}
						select
						value={selectedSkuType}
						onChange={(e) => {
							setSelectedSkuType(e?.target.value);
						}}
					>
						{skuTypes?.map((ele) => {
							return (
								<MenuItem key={ele} value={ele}>
									{ele}
								</MenuItem>
							);
						})}
					</TextField> */}
					<SelectPicker
						data={skuTypes?.map((ele) => {
							return {
								label: ele,
								value: ele,
							};
						})}
						onChange={(skuTypeValue) => {
							setSelectedSkuType(skuTypeValue);
						}}
						cleanable={false}
						searchable={false}
						style={{
							width: 150,
						}}
						placeholder='SKU Type'
					/>
				</div>
				<div className='flex flex-row gap-2'>
					{selectedStore && (nonInternal || isInternal) && (
						<Button
							variant='contained'
							className={styles.button}
							onClick={uploadVariantsThresholdData}
						>
							Update Threshold
						</Button>
					)}
					{Object.keys(updateState ?? {})?.length > 0 &&
						level !== 1 && (
							<Button
								variant='contained'
								className={styles.button}
								onClick={onSubmit}
							>
								Submit
							</Button>
						)}
				</div>
			</div>
			<div
				onScroll={handleScroll}
				ref={listRef}
				className={styles['list-container']}
			>
				<ListTable
					useWindowScroll={false}
					onScroll={handleScroll}
					colMap={COLMAP}
					columns={[...TABLE_COLS, ...SPECIAL_COLUMNS]}
					data={filteredData}
					fixedHeaderTop={0}
					listRef={listRef}
					showTotal
					actions={[...ACTION_COLUMNS]}
					special={SPECIAL_ITEMS}
					classname={styles.table}
					onExportClick={handleExport}
					onImportClick={handleImport}
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const data = state.form.VARIANTS_THRESHOLD.data.LIST_DATA;
	const stores = state?.form?.STORES?.data?.LIST;
	const { uploadDataModal } = state.modal;
	const showUploadDataModal = uploadDataModal?.show;
	const payload = uploadDataModal?.data;
	const { userPermissions, navState } = state?.navigation;
	const { userList } = state?.auth;
	return {
		data,
		stores,
		showUploadDataModal,
		payload,
		userPermissions,
		navState,
		userList,
	};
};

const mapDispatchToProps = {
	fetchVariantsThreshold: formActions.gateway,
	fetchStoresList: formActions.gateway,
	updateVariantsThresholdList: formActions.updateFields,
	toggleUploadDataModal: modalActions.toggleUploadDataModal,
	fetchUserList: authActions?.fetchUserList,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(VariantsThresholdListPage);
